<template>
  <div class="w-100 d-flex d-inline">


    <div class="h-100 w-75 pr-3 ">
      <div class="contenedorFiltros ">
        <!-- Header -->
        <div class="headerFiltros ">
          <!-- Titulo -->
          <h5 class="pt-3 pl-3">Filtros</h5>
          <hr />

          <!-- Fila 1 -->
          <div class="d-flex p-3">

            <!-- Fecha de Inicio -->
            <label class="w-100 mr-3">
              Fecha Inicio
              <input type="date"
                     class="form-control"
                     placeholder="Fecha Inicio"
                     v-model="fechaInicioFiltro">
            </label>

            <!-- Fecha Final -->
            <label class="w-100 mr-3">
              Fecha Final
              <input type="date"
                     class="form-control"
                     placeholder="Fecha Final"
                     v-model="fechaTerminoFiltro">
            </label>


            <!-- POD -->
            <ui-select
              :options="data.puertos"
              class="w-100 mr-3 mt-2"
              has-search
              label="POD"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="podFiltro"
            ></ui-select>

            <!-- Estado -->
            <ui-select
              :options="data.estados"
              class="w-100 mr-3 mt-2"
              has-search
              label="Estado"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="estadoFiltro"
            ></ui-select>
          </div>

          <!-- Fila 2 -->
          <div class="d-flex p-3">
            <!-- Nave -->
            <ui-select
              :options="data.naves"
              class="w-100 mr-3"
              has-search
              label="Nave"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="naveFiltro"
            ></ui-select>

            <!-- Cliente -->
            <ui-select
              v-if="usuarioActual.id_role !== 3"
              :options="data.clientes"
              class="w-100 mr-3"
              has-search
              label="Cliente"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="clienteFiltro"
            ></ui-select>

            <!-- Naviera -->
            <ui-select
              :options="data.navieras"
              class="w-100 mr-3"
              has-search
              label="Naviera"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="navieraFiltro"
            ></ui-select>

            <div class="w-100 mr-3"></div>
            <div class="w-100 mr-3"></div>
          </div>

          <!-- Footer -->
          <div class="d-flex justify-content-between mt-5">

            <div style="float: right" class="d-flex justify-content-end  mr-3 mb-3">
              <button class="btn btn-secondary ml-3 " @click="clear">Limpiar</button>
            </div>
            <div>
              <button class="btn btn-danger mr-3" :disabled="btnDisabled" @click="generarReporteGeneral">
                <i class="fa fa-download"></i> Generar
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="contenedorFiltros h-100 w-25">
      <!-- Header -->
      <div class="headerFiltros">
        <!-- Titulo -->
        <h5 class="pt-3 pl-3">Información Reporte</h5>
        <hr />

        <h6 class="pl-3">Reporte actualizado al: {{ data.ultima_actualizacion }} </h6>
        <h6 class="pl-3">Reporte actualizado por: {{ data.actualizado_por }} </h6>
        <!--<h6 class="pl-3">**Reporte general se actualizará cada 30 mins.** </h6> -->
        <br />
        <br />
        <!--
        <h6 class="pl-3 pb-3">Actualizado por: {{ data.actualizado_por }}</h6> 
        
        <div class="d-flex pl-3 pb-3">
          <button  class="btn btn-danger mr-3" :disabled="btnDisabled" @click="generarReporteGeneral">
            <i class="fas fa-sync-alt"></i> Actualizar informe
          </button>
        </div>
        -->
      </div>
    </div>
  </div>

</template>

<script>

// import { mapState } from "vuex";

// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import { exportGeneralReport, getGeneralLineas } from "../../../constants/lineas";
import { mapState } from "vuex";


export default {
  props: {
    dataGeneralLineas: Object
  },

  computed: {
    ...mapState(["usuarioActual"])
  },

  data() {
    return {
      //form de filtro
      fechaInicioFiltro: "",
      fechaTerminoFiltro: "",
      podFiltro: "",
      estadoFiltro: "",
      naveFiltro: "",
      navieraFiltro: "",
      clienteFiltro: "",
      //filters
      filters: {
        fecha_inicial: null,
        fecha_final: null,
        pod: null,
        estado: null,
        nave: null,
        naviera: null,
        cliente: null
      },
      //
      btnDisabled: false,
      //
      data: {
        actualizado_por: "",
        ultima_actualizacion: "",
        estados: [],
        naves: [],
        navieras: [],
        puertos: [],
        clientes: []
      }
    };
  },


  components: {
    UiSelect
  },

  methods: {
    async getDataGeneralLineas() {
      this.data = await getGeneralLineas();
    },
    clear() {
      //dropdowns
      this.fechaInicioFiltro = "";
      this.fechaTerminoFiltro = "";
      this.podFiltro = "";
      this.estadoFiltro = "";
      this.naveFiltro = "";
      this.navieraFiltro = "";
      this.clienteFiltro = "";
      //filtros
      this.filters = {
        fecha_inicial: null,
        fecha_final: null,
        pod: null,
        estado: null,
        nave: null,
        naviera: null,
        cliente: null
      };
    },
    async generarReporteGeneral() {

      try {

        this.btnDisabled = true;

        this.$vToastify.loader("Generando solicitud de reporte general...");

        let any_filter = false;

        if (this.fechaInicioFiltro) {
          this.filters.fecha_inicial = this.fechaInicioFiltro;
          any_filter = true;
        }

        if (this.fechaTerminoFiltro) {
          this.filters.fecha_final = this.fechaTerminoFiltro;
          any_filter = true;
        }

        if (this.podFiltro) {
          this.filters.pod = this.podFiltro.id;
          any_filter = true;
        }

        if (this.estadoFiltro) {
          this.filters.estado = this.estadoFiltro.id;
          any_filter = true;
        }

        if (this.naveFiltro) {
          this.filters.nave = this.naveFiltro.id;
          any_filter = true;
        }

        if (this.navieraFiltro) {
          this.filters.naviera = this.navieraFiltro.id;
          any_filter = true;
        }

        if (this.clienteFiltro) {
          this.filters.cliente = this.clienteFiltro.id;
          any_filter = true;
        }

        let response = await exportGeneralReport(any_filter ? this.filters : []);

        if (response.code === 200) {

          this.clear();

          await this.getDataGeneralLineas();

          this.$vToastify.success(response.message, "Éxito");

        } else {

          this.$vToastify.error(response.message, "Error");

        }

        this.$vToastify.stopLoader();

      } catch (error) {

        this.$vToastify.error(
          "Error al actualizar reporte General",
          "Error"
        );

      }

      this.btnDisabled = false;
      this.$vToastify.stopLoader();

    }

    // async descargarReporteGeneral() {
    //
    //   this.btnDisabled = true;
    //   this.$vToastify.loader("Generando Reporte...");
    //
    //   // const headersReporte =  {
    //   //   ["Anno"] : " ",
    //   //   ["Sem"] : " ",
    //   //   ["Cliente"] : " ",
    //   //   ["Shipper"] : " ",
    //   //   ["Consignatario"] : " ",
    //   //   ["Naviera"] : " ",
    //   //   ["Nave"] : " ",
    //   //   ["Viaje"] : " ",
    //   //   ["Contrato"] : " ",
    //   //   ["POL"] : " ",
    //   //   ["Transbordo"] : " ",
    //   //   ["POL_ETD"] : " ",
    //   //   ["POD"] : " ",
    //   //   ["POD_ETA"] : " ",
    //   //   ["Region_POD"] : " ",
    //   //   ["Plan"] : " ",
    //   //   ["Cant"] : " ",
    //   //   ["Emb"] : " ",
    //   //   ["Late"] : " ",
    //   //   ["N_Booking"] : " ",
    //   //   ["ID"] : " ",
    //   //   ["Productos"] : " ",
    //   //   ["Equipo"] : " ",
    //   //   ["Atmosfera"] : " ",
    //   //   ["Temp"] : " ",
    //   //   ["Vent"] : " ",
    //   //   ["Vent_CBM"] : " ",
    //   //   ["CO2"] : " ",
    //   //   ["O2"] : " ",
    //   //   ["Tipo_Flete"] : " ",
    //   //   ["Emision_de_BL"] : " ",
    //   //   ["Genset"] : " ",
    //   //   ["F_Declaración"] : " ",
    //   //   ["H_Declaración"] : " ",
    //   //   ["F_Asignado"] : " ",
    //   //   ["H_Asignado"] : " ",
    //   //   ["F_Solicitud"] : " ",
    //   //   ["H_Solicitud"] : " ",
    //   //   ["F_EDI"] : " ",
    //   //   ["H_EDI"] : " ",
    //   //   ["F_Confirmación"] : " ",
    //   //   ["H_Confirmación"] : " ",
    //   //   ["F_Stacking_Reef"] : " ",
    //   //   ["H_Stacking_Reef"] : " ",
    //   //   ["F_Embarcado"] : " ",
    //   //   ["H_Embarcado"] : " ",
    //   //   ["F_Cancelado"] : " ",
    //   //   ["H_Cancelado"] : " ",
    //   //   ["Comentarios"] : " ",
    //   //   ["Ultima Actualización"] : " ",
    //   //   ["Estatus"] : " ",
    //   //   ["Categoria_Producto"] : " ",
    //   //   ["Tratamiento_Frio"] : " ",
    //   //   ["Deposito"] : " ",
    //   //   ["Destino Final"] : " ",
    //   //   ["Tipo Tarifa"] : " ",
    //   //   ["Nombre Contrato"] : " ",
    //   //   ["Declarado_por"] : " ",
    //   //   ["Asignado_por"] : " ",
    //   //   ["Solicitado_por"] : " ",
    //   //   ["Edi_por"] : " ",
    //   //   ["Confirmado_por"] : " ",
    //   //   ["Embarcado_por"] : " ",
    //   //   ["Cancelado_por"] : " ",
    //   //   ["Servicio"] : " ",
    //   //   ["id_tarifa_linea"] : " ",
    //   //   ["servicio_integral"] : " ",
    //   //   ["tipo_servicio_integral"] : " ",
    //   //   ["cliente_integral"] : " ",
    //   // };
    //
    //   // const form = {
    //   //   fecha_inicio  : this.fechaInicioFiltro  ?? '',
    //   //   fecha_final   : this.fechaTerminoFiltro ?? '',
    //   //   pod           : this.podFiltro.id       ?? '',
    //   //   estado        : this.estadoFiltro.id    ?? '',
    //   //   nave          : this.naveFiltro.id      ?? '',
    //   //   naviera       : this.navieraFiltro.id   ?? '',
    //   //   cliente       : this.clienteFiltro.id   ?? '',
    //   // }
    //
    //
    //   // await exportGeneralReport(form);
    //
    //
    //   // if ( response.length == 0 ) {
    //
    //   //   result.push( headersReporte );
    //
    //   // }else{
    //
    //   //   result = response.map( (element) => {
    //
    //   //     return {
    //   //       ["Anno"]: element.Anno,
    //   //       ["Sem"]: element.Sem,
    //   //       ["Cliente"]: element.Cliente,
    //   //       ["Shipper"]: element.Shipper,
    //   //       ["Consignatario"]: element.Consignatario,
    //   //       ["Naviera"]: element.Naviera,
    //   //       ["Nave"]: element.Nave,
    //   //       ["Viaje"]: element.Viaje,
    //   //       ["Contrato"]: element.Contrato,
    //   //       ["POL"]: element.POL,
    //   //       ["Transbordo"]: element.Transbordo,
    //   //       ["POL_ETD"]: element.POL_ETD,
    //   //       ["POD"]: element.POD,
    //   //       ["POD_ETA"]: element.POD_ETA,
    //   //       ["Region_POD"]: element.Region_POD,
    //   //       ["Plan"]: element.Plan,
    //   //       ["Cant"]: element.Cant,
    //   //       ["Emb"]: element.Emb,
    //   //       ["Late"]: element.Late,
    //   //       ["N_Booking"]: element.N_Booking,
    //   //       ["ID"]: element.ID,
    //   //       ["Productos"]: element.Productos,
    //   //       ["Equipo"]: element.Equipo,
    //   //       ["Atmosfera"]: element.Atmosfera,
    //   //       ["Temp"]: element.Temp,
    //   //       ["Vent"]: element.Vent,
    //   //       ["Vent_CBM"]: element.Vent_CBM,
    //   //       ["CO2"]: element.CO2,
    //   //       ["O2"]: element.O2,
    //   //       ["Tipo_Flete"]: element.Tipo_Flete,
    //   //       ["Emision_de_BL"]: element.Emision_de_BL,
    //   //       ["Genset"]: element.Genset,
    //   //       ["F_Declaracion"]: element.F_Declaracion,
    //   //       ["H_Declaracion"]: element.H_Declaracion,
    //   //       ["F_Asignado"]: element.F_Asignado,
    //   //       ["H_Asignado"]: element.H_Asignado,
    //   //       ["F_Solicitud"]: element.F_Solicitud,
    //   //       ["H_Solicitud"]: element.H_Solicitud,
    //   //       ["F_EDI"]: element.F_EDI,
    //   //       ["H_EDI"]: element.H_EDI,
    //   //       ["F_Confirmacion"]: element.F_Confirmacion,
    //   //       ["H_Confirmacion"]: element.H_Confirmacion,
    //   //       ["F_Stacking_Reef"]: element.F_Stacking_Reef,
    //   //       ["H_Stacking_Reef"]: element.H_Stacking_Reef,
    //   //       ["F_Embarcado"]: element.F_Embarcado,
    //   //       ["H_Embarcado"]: element.H_Embarcado,
    //   //       ["F_Cancelado"]: element.F_Cancelado,
    //   //       ["H_Cancelado"]: element.H_Cancelado,
    //   //       ["Comentarios"]: element.Comentarios,
    //   //       ["Ultima Actualización"]: element.Ultima_Actualizacion,
    //   //       ["Estatus"]: element.Estatus,
    //   //       ["Categoria_Producto"]: element.Categoria_Producto,
    //   //       ["Tratamiento_Frio"]: element.Tratamiento_Frio,
    //   //       ["Deposito"]: element.Deposito,
    //   //       ["Destino Final"]: element.Destino_final,
    //   //       ["Tipo Tarifa"]: element.Tipo_Tarifa,
    //   //       ["Nombre_Contrato"]: element.Nombre_Contrato,
    //   //       ["Declarado_por"]: element.Declarado_por,
    //   //       ["Asignado_por"]: element.Asignado_por,
    //   //       ["Solicitado_por"]: element.Solicitado_por,
    //   //       ["Edi_por"]: element.Edi_por,
    //   //       ["Confirmado_por"]: element.Confirmado_por,
    //   //       ["Embarcado_por"]: element.Embarcado_por,
    //   //       ["Cancelado_por"]: element.Cancelado_por,
    //   //       ["Servicio"]: element.Servicio,
    //   //       ["id_tarifa_linea"]: element.id_tarifa_linea,
    //   //       ["servicio_integral"]: element.servicio_integral,
    //   //       ["tipo_servicio_integral"]: element.tipo_servicio_integral,
    //   //       ["cliente_integral"]: element.cliente_integral,
    //   //       ["carrier_booking_number"]: element.carrier_booking_number,
    //   //       ["naviera_salida"]: element.naviera_salida,
    //   //     }
    //   //   });
    //
    //   // }
    //
    //   // const fileName = "reporte_general";
    //   // const exportType = exportFromJSON.types.xls;
    //
    //   // exportFromJSON({ data: result, fileName, exportType });
    //
    //
    //   this.btnDisabled = false;
    //   this.$vToastify.stopLoader();
    //
    // },
  },


  created() {

    this.getDataGeneralLineas();

  }

};
</script>
